import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { MessageSquarePlus } from "lucide-react";

export default function InteractionLogsPanel({ project, canEdit, onChanged }) {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSaving(true);
    try {
      await api.post(`/design/projects/${project.id}/log`, { text: text.trim() });
      setText("");
      onChanged();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setSaving(false); }
  };

  const logs = [...(project.interaction_logs || [])].reverse();

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-gray-500">Interaction log · {logs.length}</p>
      </div>
      {canEdit && (
        <form onSubmit={submit} className="mb-4 flex gap-2">
          <input
            value={text} onChange={(e) => setText(e.target.value)}
            placeholder="Log a client interaction, phone call, note…"
            className="iz-input flex-1" data-testid="log-input"
          />
          <button type="submit" disabled={saving || !text.trim()} className="iz-btn-primary flex items-center gap-1" data-testid="log-submit">
            <MessageSquarePlus className="w-4 h-4"/> Log
          </button>
        </form>
      )}
      <div className="space-y-2 max-h-[280px] overflow-y-auto">
        {logs.length === 0 ? (
          <p className="text-xs text-gray-600 text-center py-6 border border-dashed border-[#262626] rounded">No interactions logged yet.</p>
        ) : logs.map((l, i) => (
          <div key={i} className="p-3 rounded-md border border-[#262626] bg-[#0e0e0e]">
            <div className="flex items-center justify-between mb-1">
              <p className="text-[11px] text-[#d4af37] font-mono">{l.by_user_name || "Designer"}</p>
              <p className="text-[10px] text-gray-600 font-mono">{new Date(l.at).toLocaleString()}</p>
            </div>
            <p className="text-sm text-gray-300">{l.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
